export enum OrderStatus {
    Draft = 'Draft',
    Sold = 'Sold',
}
